export const ReactAttributes = new Set(['className', 'htmlFor', 'tabIndex']);
